import * as React from "react";
const Ship = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { clipPath: "url(#prefix__a)" },
        React.createElement("mask", { id: "prefix__b", width: 96, height: 96, x: 0, y: 0, maskUnits: "userSpaceOnUse", style: {
                maskType: "luminance",
            } },
            React.createElement("path", { fill: "#fff", d: "M95.5.5H.5v95h95z" })),
        React.createElement("g", { mask: "url(#prefix__b)" },
            React.createElement("path", { fill: "#ED0000", d: "M79.6 16.3H16.3V48h63.3z" }),
            React.createElement("path", { fill: "#3F3F3F", d: "M.9 48.1C.9 74.1 22 95.2 48 95.2V24.6z" }),
            React.createElement("path", { fill: "#CFCFCF", d: "M48 24.6v70.6c26 0 47.1-21.1 47.1-47.1z" }),
            React.createElement("path", { fill: "#3F3F3F", d: "M63.9.5H32.2v15.8h31.7z" }))),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "prefix__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h96v96H0z" })))));
export default Ship;
//# sourceMappingURL=Ship.js.map